/* eslint-disable camelcase */
class Template {
  constructor(courseTemplate) {
    this.uid = courseTemplate.id;
    this.sessionDuration = courseTemplate.session_duration;
    this.totalLessons = courseTemplate.total_lessons;
    this.title = courseTemplate.title;
    this.description = courseTemplate.description;
    this.quizzes = courseTemplate?.quizzes || [];
    this.goal = courseTemplate.goal;
    this.goal.name = courseTemplate.goal.goal_name;
    this.goal.uid = courseTemplate.goal.goal_uid;
    this.topics = courseTemplate?.topics || [];
    this.liveClasses = courseTemplate?.live_classes || [];
    this.courseType = courseTemplate.course_type;
    this.state = courseTemplate.state;
    this.exams = courseTemplate?.exams || [];
    this.totalQuizzes = courseTemplate.total_quizzes;
    this.totalDuration = courseTemplate.total_duration;
    this.topicGroups = courseTemplate.topic_groups;
    this.createdAt = courseTemplate.created_at;
    this.selectedClasses = [];
    this.isContentOperator = courseTemplate.is_content_operator;
    this.driveDetails = courseTemplate.drive_details;
    if (courseTemplate.class_preference_uids)
      this.selectedClasses = courseTemplate?.class_preference_uids;

    this.lessonsDuration = courseTemplate.lessons_duration;
  }
}

const getEntityData = (data) => {
  const doubt = new Template(data);
  return doubt;
};

export default {
  Template,
  getEntityData
};
